import { render, staticRenderFns } from "./IssueBasicList.vue?vue&type=template&id=2cfc7c6e&scoped=true"
import script from "./IssueBasicList.vue?vue&type=script&lang=js"
export * from "./IssueBasicList.vue?vue&type=script&lang=js"
import style0 from "./IssueBasicList.vue?vue&type=style&index=0&id=2cfc7c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc7c6e",
  null
  
)

export default component.exports